export default "__VITE_ASSET__B_fWs_E7__"